<!-- Created by Alex Poh. on 14/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->
<img class="img" src="assets/images/demo/fake-pages/Gant-Chart.svg" alt="icon" />
